import { NextArrow } from '../../../Icons/SliderArrows';
import { ICarouselArrow } from './carouselArrow.types';

export const CarouselNextArrow: React.FC<ICarouselArrow> = ({
  classes = '',
  onClick = () => {},
}): JSX.Element => {
  return (
    <div
      className={` bg-gradient-to-r from-[#FFFFFF]/10 to-[#DDDDDD]/70 h-full absolute z-10 top-0 bottom-0 right-0 ${classes}`}
    >
      <div
        className={`border rounded-3xl w-auto p-3 absolute z-10 top-44 right-4 cursor-pointer bg-white inline-block`}
        onClick={onClick}
      >
        <NextArrow />
      </div>
    </div>
  );
};
